module.exports = __webpack_public_path__ + "img/popup-illustration.af094093.svg";